// 分享链接
export const shareUrl = () => {
  let url = `https://${window.location.host}${window.location.pathname}`;
  return url;
};

// 分享标题
export const shareTitle = () => {
  return `《尘白禁区》1月29日全新限时活动【自往昔归还】开启！`;
};

// 分享描述
export const shareDesc = () => {
  return `美少女射击游戏《尘白禁区》1月29日全新限时活动【自往昔归还】开启！点击进入主题页【${shareUrl()}】抽取官方周边礼品~`;
};
